import 'script-loader!../vendor/DomainsOrg.navigation.js';

/**
 * The class is used for the responsive top navigation. The DomainsOrg modal component is used
 */
export default class Navigation {
	/**
	 * Our constructor
	 *
	 * @return void
	 */
	constructor() {
		this.initialize();
	}

	/**
	 * Initializes the navigation for all pages
	 *
	 * @return void
	 */
	initialize() {
		if ( typeof window.DomainsOrg !== 'object' ) {
			window.DomainsOrg = {};
		}

		window.DomainsOrg.navigation( {
			'target': '#js-menu-primary-wrapper',
			'toggle': '#js-menu-toggle',
			'sub_menu_open': 'hover'
		}, function() {
		} );
	}
}